import React, { useEffect } from 'react';
import styled from 'styled-components';
import ContentLoader from 'react-content-loader';
import { useHistory } from 'react-router-dom';

import Hero from './HeroSection/Hero';
import useThemes from '../hooks/useThemes';
import Card from './Cards/Card';
import { useApi } from '../hooks/useApi';

export const PageNews = () => {
  window.scroll(0, 0)
  const { backgroundWhite, backgroundSeptimo, colorPrincipal } = useThemes();
  const { noticias, getNoticias } = useApi();
  const history = useHistory();

  useEffect(() => {
    getNoticias();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container background={backgroundWhite}>
      <Hero
        color={backgroundWhite}
        title='Noticias'
        subtitle='Entérate de las principales novedades en famedic'
        imgSrc='img/Servicios/Citas-turnos.jpg'
      />

      {noticias.isLoading ? (
        <div className='grid-container'>
          {[...Array(6).keys()].map((_, index) => (
            <div className='grid-item' key={index}>
              <ContentLoader
                speed={2}
                width='100%'
                height='auto'
                foregroundColor={colorPrincipal}
                backgroundColor={backgroundSeptimo}
              >
                <rect x='0' y='0' rx='30' ry='30' width='100%' height='500' />
              </ContentLoader>
            </div>
          ))}
        </div>
      ) : (
        <div className='grid-container'>
          {noticias.data.map((item) => (
            <Card
              img={item.imagen}
              titulo={item.titulo}
              key={item.id}
              onClick={() =>
                history.push({
                  pathname: '/unanoticia',
                  state: { noticia: item, noticias: noticias.data },
                })
              }
            />
          ))}
        </div>
      )}
    </Container>
  );
};

// ##### Estilos #####
const Container = styled.div`
  background-color: ${(props) => props.background};
  padding-bottom: 5rem;

  .grid-container {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(auto-fit, minmax(36rem, 1fr));
    margin-top: 5vh;
    padding: 1rem 10rem;

    .grid-item {
      min-height: 50rem;
      min-width: 36rem;
    }
  }

  @media (max-width: 1023px) {
    .grid-container {
      grid-template-columns: repeat(auto-fit, minmax(26rem, 1fr));
      padding: 2rem;

      .grid-item {
        min-width: 16rem;
      }
    }
  }
`;
